import { CitizenCategory, GroupedUsedCardsStat, citizenCategoryShorthand, salesPointGetAddress } from '@prodcard/core'
import { Workbook } from 'exceljs'
import { map, mapValues, size, sum, toArray } from 'lodash'

export function createSheetUsedCardsStats(
  workbook: Workbook,
  sheetName: string,
  opts: { groupedBySP: GroupedUsedCardsStat[]; groupedByME: GroupedUsedCardsStat[] },
) {
  const worksheet = workbook.addWorksheet(sheetName)

  worksheet.columns = [
    { header: 'Муниципальное образование', width: 40 },
    { header: 'Торговый объект', width: 40 },
    ...map(CitizenCategory, cc => ({ header: citizenCategoryShorthand(cc), key: cc })),
  ]

  const sumByCategory: Record<CitizenCategory, number> = mapValues(CitizenCategory, () => 0)

  opts.groupedByME.forEach(itemME => {
    worksheet.addRow([
      itemME.municipalEntity.name,
      '',
      ...map(CitizenCategory, cc => {
        sumByCategory[cc] += itemME.values[cc]

        return itemME.values[cc]
      }),
    ])

    opts.groupedBySP
      .filter(i => i.municipalEntity.id === itemME.municipalEntity.id)
      .forEach(itemCIP => {
        worksheet.addRow([
          '',
          salesPointGetAddress(itemCIP.salesPoint) +
            (itemCIP.salesPoint.comment ? ` (${itemCIP.salesPoint.comment})` : ''),
          ...map(CitizenCategory, cc => itemCIP.values[cc]),
        ])
      })
  })

  if (opts.groupedByME.length > 1)
    worksheet.addRow(['Итого по категориям:', '', ...map(CitizenCategory, cc => sumByCategory[cc])])
  worksheet.addRow(['Общий итог:', '', ...new Array(size(CitizenCategory) - 1), sum(toArray(sumByCategory))])
}
